import {
  Box,
  Button,
  Card,
  CardActions,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { GetBubbleImages } from "../../DAL/fetch";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useNavigate } from "react-router-dom";
import { fileUrl } from "../../Config/Config";
import AlertDialog from "../../Components/Models/AlertDialog";
import { DeleteBubbleImage } from "../../DAL/delete";
import { enqueueSnackbar } from "notistack";

export const TextBubbleImages = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [imageId, setImageId] = useState("");
  const [loading, setLoading] = useState(false);

  const FetchAllBubbleImages = async () => {
    setLoading(true);
    const resp = await GetBubbleImages();
    if (resp.status == 200) {
      setData(resp?.data?.data);
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setImageId(id);
    setOpen(true);
  };
  const handleModelDelete = async () => {
    const resp = await DeleteBubbleImage(imageId);
    if (resp.data?.statusCode == 200) {
      setOpen(false);
      FetchAllBubbleImages();
    } else {
      enqueueSnackbar(resp?.data?.message, { variant: "error" });
    }
  };
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    FetchAllBubbleImages();
  }, []);
  return (
    <>
      <AlertDialog
        open={open}
        onDelete={handleModelDelete}
        onCancel={handleCancel}
      />
      {loading == true ? (
        <Box sx={{ marginLeft: "50%", marginTop: "20%" }}>
          <CircularProgress sx={{ color: "purple" }} />
        </Box>
      ) : (
        <Container maxWidth={"xl"} sx={{ marginTop: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">Text Bubbles List</Typography>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
                borderRadius: "6px",
                textTransform: "none",
              }}
              onClick={() => navigate("/add-text-bubble")}
            >
              Add Text Bubble
            </Button>
          </Box>

          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            {data?.map((val) => {
              return (
                <>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <Card sx={{ maxWidth: 345, borderRadius: "10px" }}>
                      <CardMedia
                        sx={{ height: 160 }}
                        image={fileUrl + val?.pictureUrl}
                        title=""
                      />
                      <CardActions>
                        <BorderColorIcon
                          sx={{ color: "green", cursor: "pointer" }}
                          onClick={() =>
                            navigate(`/edit-text-bubble/${val?.id}`)
                          }
                        />

                        <DeleteIcon
                          sx={{ color: "red", cursor: "pointer" }}
                          onClick={() => handleDelete(val?.id)}
                        />
                      </CardActions>
                    </Card>
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Container>
      )}
    </>
  );
};
